import { Pipe, PipeTransform } from '@angular/core';
import { BaseCustomerInquiryOfferDateInterface, OfferBubbleValues, BaseInquiryShiftsWithFlexType } from 'base';

@Pipe({
  name: 'baseCustomerOfferAvailableShiftTypeExists',
})
export class BaseCustomerOfferAvailableShiftTypeExistsPipe implements PipeTransform {
  transform(dates: BaseCustomerInquiryOfferDateInterface[], shiftType: BaseInquiryShiftsWithFlexType): boolean {
    return dates.some((dateItem) => {
      const shiftItemToCheck = dateItem.shifts.find((shiftItem) => shiftItem.shift === shiftType);
      return (
        shiftItemToCheck?.currentValue === OfferBubbleValues.OfferedByServiceProvider ||
        shiftItemToCheck?.currentValue === OfferBubbleValues.Booked ||
        shiftItemToCheck?.currentValue === OfferBubbleValues.NeedsConfirmation ||
        shiftItemToCheck?.currentValue === OfferBubbleValues.Rejected
      );
    });
  }
}
